module.exports = __webpack_public_path__ + "static/img/plat2.bac98450.png";